exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box .box-body .table tr td {\r\n  padding: 8px;\r\n  width: 100%;\r\n  white-space: nowrap;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/manageLead/email-leads/email-leads.component.css
// module id = ../../../../../src/app/manageLead/email-leads/email-leads.component.css
// module chunks = main